import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { apiRequest } from "./api";

// get Token
import useAuthToken from "../../Hooks/useAuthToken";

export const useCreateVideo = () => {
  const token = useAuthToken();

  const createVideo = async (credentials) => {
    if (!credentials) {
      throw new Error("Please provide credentials");
    }
    return apiRequest("post", "/api/video", credentials, token);
  };

  return createVideo;
};

export const useGetVideo = () => {
  const token = useAuthToken();

  const getVideo = async () => {
    if (!token) {
      throw new Error("Token is missing");
    }

    return apiRequest("get", "/api/video", null, token);
  };

  return getVideo;
};

// export const useGetCategoryById = (id) => {
//   const token = useAuthToken();

//   // Function to fetch category data
//   const getCategoryById = async () => {
//     if (!token) {
//       throw new Error("Token is missing");
//     }

//     const response = await apiRequest(
//       "get",
//       `/api/category/${id}`,
//       null,
//       token
//     );

//     return response;
//   };
//   return useQuery({
//     queryKey: ["single-category", id],
//     queryFn: getCategoryById,
//     enabled: !!id,
//   });
// };

export const useUpdateVideo = (id) => {
  const token = useAuthToken();

  const updateVideo = async (formData) => {
    if (!token) {
      throw new Error("Token is missing");
    }
    const response = await apiRequest(
      "patch",
      `/api/video/${id}`,
      formData,
      token
    );

    return response;
  };

  return updateVideo;
};
